import { z } from 'zod'
import { apiEnvelope, pageSchema } from '@/shared/api/api-contract'
import { generationTaskSchema, taskCapabilitySchema } from '../model/generation-task'

export const taskEnvelopeSchema = apiEnvelope(generationTaskSchema)
export const taskListEnvelopeSchema = apiEnvelope(pageSchema(generationTaskSchema))
export const quoteEnvelopeSchema = apiEnvelope(z.object({
  modelId: z.number().int(),
  capability: taskCapabilitySchema,
  points: z.number().int(),
  pricingRuleId: z.number().int(),
  description: z.string().nullish(),
}))

export type TaskInput = Record<string, unknown>
export type TaskQuote = z.infer<typeof quoteEnvelopeSchema>['data']
